import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, NavigationStart, NavigationEnd} from '@angular/router';
import {Helpers} from "./helpers";

@Component({
	selector: 'body',
	templateUrl: './app.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
	title = 'app';
	globalBodyClass = 'home page-template-default page page-id-701  look  post_id_701 dropcaps1 site_boxed_off page-sidebar-none';

	constructor(private _router: Router) {
	}

	ngOnInit() {
		// this._router.events.subscribe((route) => {
		// 	if (route instanceof NavigationStart) {
		// 		Helpers.setLoading(true);
		// 		Helpers.bodyClass(this.globalBodyClass);
		// 	}
		// 	if (route instanceof NavigationEnd) {
		// 		Helpers.setLoading(false);
		// 	}
		// });
	}
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts